import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telephoneFormat',
})
export class TelephoneFormatPipe implements PipeTransform {
  public transform(phone: string): string {
    phone = phone.replace(/[^\d]/g, '');

    if (phone.length == 10) {
      return phone.replace(
        /(\d{1})(\d{2})(\d{3})(\d{2})(\d{2})/,
        '+$1-$2-$3-$4-$5'
      );
    }

    if (phone.length == 11) {
      return phone.replace(
        /(\d{2})(\d{2})(\d{3})(\d{2})(\d{2})/,
        '+$1-$2-$3-$4-$5'
      );
    }

    return '+' + phone;
  }
}
